import React, { useEffect, useState } from "react";
import { THEME, flexxState, flexxEvents, levelFor, LEVELS } from "./state";

// XP toasts and level-up banner (global, portalized via fixed positioning)
export function XPNotifications() {
  const [toast, setToast] = useState(null);
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    const offXp = flexxEvents.on("xp", (e) => {
      if (!e || !e.amount) return;
      const id = Math.random();
      setToast({ id, amount: e.amount, reason: e.reason });
      setTimeout(() => setToast((t) => (t && t.id === id ? null : t)), 1700);
    });
    const offLvl = flexxEvents.on("levelup", (e) => {
      const id = Math.random();
      setBanner({ id, level: e.level });
      setTimeout(() => setBanner((b) => (b && b.id === id ? null : b)), 3600);
    });
    return () => { offXp(); offLvl(); };
  }, []);

  return (
    <>
      {toast && (
        <div className="flexx-xp-float" data-testid="xp-toast" key={toast.id}>
          +{toast.amount} XP
        </div>
      )}
      {banner && (
        <div className="flexx-lvl-banner" data-testid="levelup-banner" key={banner.id}>
          ⚡ LEVEL UP! You are now a {banner.level.name}
        </div>
      )}
    </>
  );
}

// Header XP bar — can be slotted into the top of pages
export function XPBar({ compact }) {
  const [xp, setXp] = useState(flexxState.xp());
  useEffect(() => {
    const off = flexxEvents.on("xp", (e) => setXp(e.next));
    return off;
  }, []);
  const lvl = levelFor(xp);
  const nextMin = LEVELS[lvl.index + 1]?.min ?? lvl.max;
  const floor = lvl.min;
  const pct = Math.min(100, Math.round(((xp - floor) / Math.max(1, (nextMin - floor))) * 100));

  if (compact) {
    return (
      <div data-testid="xp-bar-compact" style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <div style={{ fontSize: 11, color: THEME.gold, fontWeight: 700, whiteSpace: "nowrap" }}>{xp} XP</div>
        <div className="flexx-progress-bar" style={{ width: 90 }}>
          <span style={{ width: `${pct}%` }} />
        </div>
        <div style={{ fontSize: 10, color: THEME.mute, whiteSpace: "nowrap" }}>{lvl.name}</div>
      </div>
    );
  }

  return (
    <div data-testid="xp-bar-full" className="flexx-card" style={{ padding: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <div>
          <div style={{ fontSize: 10, letterSpacing: 2, color: THEME.gold, fontFamily: "monospace" }}>LEVEL {lvl.index + 1}</div>
          <div style={{ color: THEME.text, fontSize: 15, fontWeight: 700 }}>{lvl.name}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ color: THEME.gold, fontSize: 18, fontWeight: 800 }}>{xp} XP</div>
          <div style={{ color: THEME.mute, fontSize: 11 }}>
            {nextMin === Infinity ? "Max level" : `${Math.max(0, nextMin - xp)} XP to next`}
          </div>
        </div>
      </div>
      <div className="flexx-progress-bar"><span style={{ width: `${pct}%` }} /></div>
    </div>
  );
}
